import { brand, whatsappUrl } from '@/content/site'
import { Icon } from '@/components/Icon'
import styles from './Contacto.module.css'

export function Contacto() {
  return (
    <section id="contacto" className="section section--soft">
      <div className="container">
        <div className={`${styles.card} reveal`}>
          <p className="eyebrow">Contacto</p>
          <h2 className={styles.title}>¿Hacemos algo juntos?</h2>
          <p className={styles.lead}>
            Si buscas una charla, capacitación, taller o quieres desarrollar una experiencia para tu
            organización, escríbeme por WhatsApp y conversemos.
          </p>

          <a href={whatsappUrl} className={`btn btn--lg ${styles.whatsapp}`} target="_blank" rel="noreferrer">
            <Icon name="whatsapp" size={22} />
            Conversar por WhatsApp
          </a>

          <p className={styles.emailLine}>
            O escríbeme a{' '}
            <a href={`mailto:${brand.email}`} className={styles.emailLink}>
              {brand.email}
            </a>
          </p>

          <div className={styles.socials}>
            <span className={styles.socialsLabel}>También en</span>
            <a href={brand.instagram} className={styles.social} target="_blank" rel="noreferrer">
              <Icon name="instagram" size={20} /> Instagram
            </a>
            <a href={brand.linkedin} className={styles.social} target="_blank" rel="noreferrer">
              <Icon name="linkedin" size={20} /> LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
